'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _DateInput = _interopRequireDefault(require("Components/Forms/Elements/DateInput"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _Select2 = _interopRequireDefault(require("@material-ui/core/Select"));
var _styles = require("@material-ui/core/styles");
var _options = _interopRequireDefault(require("Shared/options"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
const CustomListSubheader = (0, _styles.withStyles)(theme => ({
  root: {
    position: "relative"
  }
}))(props => /*#__PURE__*/_react.default.createElement(_ListSubheader.default, props));
class NewCandidateForm extends _react.Component {
  state = {
    status_messages: {},
    'candidate[handicap_status]': [],
    'candidate[acceptation]': false,
    activeStep: 0,
    skipped: []
  };
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchProfessionalDomain();
  }
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const candidate = (0, _getFormData.default)({
      state: state,
      pattern: 'candidate['
    });
    qwest.post('/candidate/create', candidate).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: "Nous vous remercions d’avoir créé votre compte. Vous allez être contacté prochainement par email pour discuter de votre demande et avoir accès à nos services. Si besoin, contactez-nous sur contact@aspiejob.org",
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      window.setTimeout(function () {
        component.login(response.login, response.pass, response.id);
      }, 3000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  login = (login, pass, id) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/login', {
      login: login,
      password: pass
    }).then(function (xhr, response) {
      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      component.setState({
        loading: false
      });
      window.setTimeout(function () {
        app.navigateTo('/mon-compte-candidat/' + id);
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        loading: false,
        ...(0, _getErrorsFromResponse.default)({
          response: response,
          error: response?.error
        })
      });
    });
  };
  handleCheckboxChange = _ref => {
    let {
      e,
      name,
      value
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleDepChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = event.value;
    const name = event.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchDepartment(event.value);
  };
  fetchDepartment = department => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.get(`https://geo.api.gouv.fr/departements?nom=${department}&limit=5`).then(data => {
      component.setState({
        autocompleteDep: JSON.parse(data.response)
      });
      component.setState({
        show_suggestions: true
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  isStepSkipped = step => {
    const component = this,
      props = this.props,
      state = this.state;
    return state.skipped.includes(step);
  };
  handleNext = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    newSkipped.push(state.activeStep);
    component.setState({
      activeStep: state.activeStep + 1,
      skipped: newSkipped
    });
  };
  handleBack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    let prevStep = state.activeStep - 1;
    const index = newSkipped.indexOf(prevStep);
    if (index > -1) {
      newSkipped.splice(index, 1);
    }
    newSkipped.filter(function (step) {
      return step !== prevStep;
    });
    component.setState({
      activeStep: state.activeStep - 1,
      skipped: newSkipped
    });
  };
  handleSkip = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    newSkipped.push(state.activeStep);
    component.setState({
      activeStep: state.activeStep + 1,
      skipped: newSkipped
    });
  };
  handleReset = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      activeStep: 0
    });
  };
  getJobOptions = job => {
    const component = this,
      props = this.props,
      state = this.state;
    const job_option = _options.default[job];
    let job_items = job_option.map(function (job_item, i) {
      let output = /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: job_item.value,
        key: job_item.value
      }, job_item.label);
      return output;
    });
    return job_items;
  };
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/professional-domain/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let professional_domains_options = (state.professional_domains || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (company_activity) {
      let option = {
        label: company_activity.label,
        value: company_activity.id
      };
      return option;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      className: "u-full-width",
      action: "/candidate/create"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations de connexion"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[login]'],
      name: "candidate[login]",
      type: "text",
      label: "E-mail (login)",
      autocomplete: "new-email",
      status: state.status_messages,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[password]'],
      name: "candidate[password]",
      type: "password",
      label: "Mot de passe (minimum 12 caract\xE8res) ",
      autocomplete: "new-password",
      status: state.status_messages,
      required: true
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Coordonn\xE9es"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[lastname]'],
      name: "candidate[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[firstname]'],
      name: "candidate[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
      onChange: component.handleChange,
      value: state['candidate[birthdate]'],
      name: "candidate[birthdate]",
      label: "Date de naissance",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[home_phone_number]'],
      name: "candidate[home_phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[phone_number]'],
      name: "candidate[phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone portable",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Adresse",
      onChange: component.handleChange,
      value: state['candidate[address][line_1]'],
      name: "candidate[address][line_1]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Compl\xE9ment d'adresse",
      onChange: component.handleChange,
      value: state['candidate[address][line_2]'],
      name: "candidate[address][line_2]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Code postal",
      onChange: component.handleChange,
      value: state['candidate[address][postal_code]'],
      name: "candidate[address][postal_code]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Ville",
      onChange: component.handleChange,
      value: state['candidate[address][city]'],
      name: "candidate[address][city]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "D\xE9partement",
      onChange: component.handleDepChange,
      value: state['candidate[department]'],
      name: "candidate[department]",
      status: state.status_messages
    }), state.show_suggestions ? /*#__PURE__*/_react.default.createElement("ul", {
      className: "sugestion-departement"
    }, state.autocompleteDep && state.autocompleteDep.map(dep => /*#__PURE__*/_react.default.createElement("li", {
      key: dep.nom,
      onClick: e => {
        component.setState({
          'candidate[department]': e.target.innerText
        });
        component.setState({
          show_suggestions: false
        });
      }
    }, dep.nom))) : undefined)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Ma situation personnelle"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "J\u2019ai un diagnostic")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_current_status]'] === 'Diagnostiqué',
      onChange: component.handleRadioChange,
      value: 'Diagnostiqué',
      color: "primary",
      name: "candidate[tsa_current_status]",
      inputProps: {
        'aria-label': 'Diagnostiqué'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_current_status]'] === "Non diagnostiqué",
      onChange: component.handleRadioChange,
      value: "Non diagnostiqué",
      color: "primary",
      name: "candidate[tsa_current_status]",
      inputProps: {
        'aria-label': 'Non diagnostiqué'
      }
    }), "Non", /*#__PURE__*/_react.default.createElement("span", {
      className: "c-form-radio--error"
    }, " ", state.status_messages?.["candidate[tsa_current_status]"]?.error, " ")), state['candidate[tsa_current_status]'] === 'Diagnostiqué' ? /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-left-25 u-padding-left-25 -u-margin-top-25 u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf, .jpg, .jpeg,",
      onChange: component.handleFileChange,
      name: 'candidate[tsa_diagnostic][file]',
      data: state,
      multiple: true,
      status: state.status_messages,
      label: "Joindre mon diagnostic (.pdf, .jpg, .jpeg)"
    })) : undefined, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "Je souhaite faire un diagnostic")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_need_diagnostic]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[tsa_need_diagnostic]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_need_diagnostic]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[tsa_need_diagnostic]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "J\u2019ai une RQTH "), " (Reconnaissance de Travailleur Handicap\xE9)"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 3,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][status]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[rqth][status]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 3,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][status]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[rqth][status]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non", /*#__PURE__*/_react.default.createElement("span", {
      className: "c-form-radio--error"
    }, " ", state.status_messages?.["candidate[tsa_current_status]"]?.error, " ")), state['candidate[rqth][status]'] === "Oui" ? /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-left-25 u-padding-left-25 -u-margin-top-25 u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf, .jpg, .jpeg,",
      onChange: component.handleFileChange,
      name: 'candidate[rqth][file]',
      data: state,
      multiple: true,
      status: state.status_messages,
      label: "Joindre mon attestation de RQTH  (.pdf, .jpg, .jpeg)"
    })) : undefined), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Se d\xE9placer"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je prend les transports en commun mais j\u2019ai des difficult\xE9es d\u2019ordre sensoriel (bruit notamment) qui peuvent m\u2019amener \xE0 \xE9viter ce type de  transport",
      name: "candidate[displacement_difficulties][difficulte]",
      value: state['candidate[displacement_difficulties][difficulte]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je prend les transports en commun",
      name: "candidate[displacement_difficulties][transport_commun]",
      value: state['candidate[displacement_difficulties][transport_commun]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je conduis",
      name: "candidate[displacement_difficulties][conduit]",
      value: state['candidate[displacement_difficulties][conduit]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je me d\xE9place \xE0 v\xE9lo",
      name: "candidate[displacement_difficulties][velo]",
      value: state['candidate[displacement_difficulties][velo]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je me d\xE9place \xE0 pied",
      name: "candidate[displacement_difficulties][a_pied]",
      value: state['candidate[displacement_difficulties][a_pied]'] === true,
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations compl\xE9mentaires"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[competences_interets]"] || '',
      name: "candidate[competences_interets]",
      label: "Mes comp\xE9tences et int\xE9r\xEAts",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[geographic_sector]'],
      name: "candidate[geographic_sector]",
      type: "text",
      label: "Secteur g\xE9ographique de ma recherche",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[working_rythm_desired_hours]'],
      name: "candidate[working_rythm_desired_hours]",
      type: "text",
      label: "Rythme de travail - horaires souhait\xE9s",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[cv_status]'] === "J'ai fait mon CV",
      onChange: component.handleRadioChange,
      value: "J'ai fait mon CV",
      color: "primary",
      name: "candidate[cv_status]",
      inputProps: {
        'aria-label': 'J\'ai fait mon CV'
      }
    }), "J'ai fait mon cv et je vous le communique ci-joint"), state['candidate[cv_status]'] === "J'ai fait mon CV" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      onChange: component.handleFileChange,
      name: "candidate[cv_download]",
      data: state,
      status: state.status_messages,
      accept: ".pdf,.jpg,.png,.odt,.gif,.docx,.jpeg",
      label: "Joindre mon CV (PDF,JPG)"
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[cv_status]'] === "Je n’ai pas fait mon CV et je souhaite de l’aide pour le rédiger",
      onChange: component.handleRadioChange,
      value: "Je n’ai pas fait mon CV et je souhaite de l’aide pour le rédiger",
      color: "primary",
      name: "candidate[cv_status]",
      inputProps: {
        'aria-label': 'Je n\'ai pas fait mon CV et je souhaite de l’aide pour le rédiger'
      }
    }), "Je n\u2019ai pas fait mon CV et je souhaite de l\u2019aide pour le r\xE9diger"), /*#__PURE__*/_react.default.createElement("span", {
      className: "c-form-radio--error"
    }, " ", state.status_messages?.["candidate[cv_status]"]?.error, " "), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleChange,
      label: "J'accepte les conditions g\xE9n\xE9rales d'utilisation",
      name: "candidate[cgu_accepted]",
      value: state['candidate[cgu_accepted]'] === true,
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/pdf/CGU.pdf",
      target: "_blank",
      className: "u-margin-top-10 c-link"
    }, "Voir les CGU"))), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, "Valider la cr\xE9ation de mon compte", loader)));
    return output;
  }
}
exports.default = NewCandidateForm;
